import React from 'react'
import { Link, Icon, Box } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  landingLink: {
    display: 'flex',
    alignItems: 'center',
    color: '#004165',
    textDecoration: 'none',
    fontSize: '0.875rem',
    fontWeight: 500,
    marginTop: theme.spacing(1),
    '&:hover': {
      textDecoration: 'underline',
      color: '#003050',
    },
  },
  linkIcon: {
    fontSize: '1rem',
    marginLeft: theme.spacing(0.5),
  },
}))

export function LandingPageLink({ href, children, onClick, ...props }) {
  const classes = useStyles()

  const handleClick = (event) => {
    if (onClick) {
      event.preventDefault()
      onClick()
    }
  }

  return (
    <Box>
      <Link
        href={href}
        onClick={handleClick}
        className={classes.landingLink}
        target="_blank"
        rel="noopener noreferrer"
        {...props}
      >
        {children}
        <Icon className={classes.linkIcon}>open_in_new</Icon>
      </Link>
    </Box>
  )
}
